import { useTranslation } from 'react-i18next'
import { SetupWizardStep, SetupWizardStepComponent } from 'app/menu/components/TopBarV1/setupWizard/SetupWizardStep'
import AddAlarmIcon from '@mui/icons-material/AddAlarm'
import N from 'utils/navigation'

export const OpeningHoursCTA: SetupWizardStepComponent = props => {
  const { t } = useTranslation()

  return (
    <SetupWizardStep
      {...props}
      step={{
        icon: <AddAlarmIcon />,
        content: t('SetupWizard.OpeningHoursSummary'),
        buttonText: t('SetupWizard.OpeningHoursCTA'),
        actionOnClick: () => {
          N.push('/settings/opening-hours')
        }
      }}
    />
  )
}
